import {Injectable} from '@angular/core';
import {UiModelService} from './ui-model.service';
import {debounceTime, take, tap, withLatestFrom} from 'rxjs/operators';
import {ValidationService} from './validation.service';
import {EventService} from './event.service';
import {Subject} from 'rxjs';
import {syncSameArtifacts, UiInputControl} from '../models/uiArtefakt';

@Injectable()
export class UiUpdateService {
  public valueChangedSubject$ = new Subject<UiInputControl>();

  constructor(private _eventService: EventService, private _uiModelService: UiModelService,
              private _validationService: ValidationService) {
    this.valueChangedSubject$.pipe(
        tap(artefakt => artefakt.UIMeldung = []),
        debounceTime(300)).subscribe(artefakt => {
      this._eventService.uiControls$.pipe(
          withLatestFrom(this._validationService.calcFormsValid$),
          take(1)).subscribe(([uiControl, canCalculate]) => {
        syncSameArtifacts(uiControl, artefakt);
        this._uiModelService.requestUiControl(uiControl).subscribe();
      });
    });
  }
}
